import { request } from '@/utils/request';

export const fetchSchools = async (params = {}) => (await request.get('/user/schools/', { params })).data;
export const updateSchool = async school => (await request.patch('/user/me/', { school })).data;
export const bindPostSchool = async postId => (await request.post(`/post/${postId}/school/`, {})).data;
export const fetchPublicProfile = async userId => (await request.get(`/user/profiles/${userId}/`)).data;
export const fetchPublicPosts = async (userId, params = {}) => (await request.get(`/user/profiles/${userId}/posts/`, { params })).data;
export const requestRegistrationCode = async email => (await request.post('/user/register/email-code/', { email }, { timeout: 30000 })).data;
